/**
 *
 * Ask
 *
 */

export const QaTitleModelMixin = {
  name: 'QaTitleModelMixin',

  data: () => {
    return {
      qaTitle: '',
    };
  },

  computed: {
    c_isQaTitleBlank() {
      return '' === this.qaTitle;
    },

    c_isQaTitleToolong() {
      return !this.c_isQaTitleBlank && this.qaTitle.length > 64;
    },
  },
};

export default QaTitleModelMixin;
